import { render, staticRenderFns } from "./ObservationDetail.vue?vue&type=template&id=7fb8df44&"
import script from "./ObservationDetail.vue?vue&type=script&lang=js&"
export * from "./ObservationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports